import { useTranslation } from "react-i18next";

const LanguageSwitcher = ({ setLanguage, language }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="h-11 min-w-11 px-3 rounded-md text-xs font-bold text-muted bg-secondary hover:bg-secondary-dark transition-colors"
      onClick={() => setLanguage(language === "en" ? "he" : "en")}
      aria-label={
        language === "en" ? t("Switch to Hebrew") : t("Switch to English")
      }
    >
      {language === "en" ? "עב" : "EN"}
    </button>
  );
};

export default LanguageSwitcher;
